import { render, staticRenderFns } from "./TableFieldEditor.vue?vue&type=template&id=fa0f076a&"
import script from "./TableFieldEditor.vue?vue&type=script&lang=js&"
export * from "./TableFieldEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports